// CARO. Casa de estilo — stable per-browser cart id for stock pre-reservations.

const KEY = 'caro.cartId';

export function getCartId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage unavailable → ephemeral id (holds simply won't persist).
    return 'anon-' + Math.random().toString(36).slice(2);
  }
}
